import * as angular from 'angular';
import * as angularResource from 'angular-resource';
import { ngxFeatureFlagServiceModule } from '@go-modules/services/feature-flag';

import { UserGroupModel } from './user-group.factory';

export const userGroupModel = angular.module('go.models.userGroup', [
	angularResource,
	ngxFeatureFlagServiceModule
])
	.factory(UserGroupModel.NG1_INJECTION_NAME, UserGroupModel)
	.name;
